export default "__VITE_ASSET__BxIKUlUu__"